import { AlertConfirm } from "../components/alert";
import { Fetch } from "./fetch";

export const removeSpecial=(string)=>{
  return string;
}


// Elimina claves con valores vacíos del objeto:
// - string vacío (tras trim)
// - null o undefined
// - objeto vacío {}
// - array vacío []
// Nota: conserva false y 0 como valores válidos.
export const cleanEmptyFields = (input) => {
  if (!input || typeof input !== 'object' || Array.isArray(input)) return input;

  const out = { ...input };
  const isEmpty = (val) => {
    if (val === null || val === undefined) return true;
    if (typeof val === 'string') return val.trim() === '';
    if (Array.isArray(val)) return val.length === 0;
    if (typeof val === 'object') return Object.keys(val).length === 0;
    return false;
  };

  ['created_by', 'updated_by','creado_por'].forEach((k) => {
    if (k in out && isEmpty(out[k])) {
      delete out[k];
    }
  });

  return out;
};


export const removeSpecialJodit=(string)=>{
  // eslint-disable-next-line no-control-regex
  var cleanedString = string.replace(/[^\x00-\x7F\u00F1\u00D1áéíóúÁÉÍÓÚ¡?¿!()]/g, '').replace(/"/g, '\\"');
    return cleanedString;
  }

  export const eliminarImagen=async (id)=>{    
    return new Promise((resolve,reject)=>{
      AlertConfirm("¿Estás seguro?","La imagen se eliminará permanentemente y no será posible recuperarla.", 'question', (response) => {        
        if (response.isConfirmed) {
          Fetch(`upload/files/${id}`, "delete").then((data)=>{resolve(data)});          
        }else{
          reject(1)
        }
    });      
    });
    
  }
